import styled from "@emotion/styled";

export const ModalContent = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	gap: 16px;
	outline: none;
	max-width: 600px;
	width: 100%;
	background: var(--modalBackground);
	padding: 16px 20px 32px;
	border-radius: 20px;
	text-align: center;
	color: #ffffff;
	@media screen and (max-width: 640px) {
		max-width: calc(100% - 32px);
		width: 100%;
	}

	button {
		max-width: 300px;
	}
`;

export const ModalCloseBlock = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
	align-items: center;

	button {
		padding: 0;

		svg {
			width: 32px;
			height: 32px;
			color: #fff;
		}
	}
`;
